$(function() {
  $('#subscribeForm').parent().find('.submit-success, .submit-error').hide();
  $('#subscribeForm').on('submit', function() {
    var form = $(this);
    form.parent().find('.submit-success, .submit-error').hide();
    var email = $(this).find('input').val();

    $.ajax({
      url: window.subscribeUrl,
      type: 'post',
      dataType: 'json',
      data: {
        email: email,
      },
    }).done(function(response) {
      form.parent().find('.submit-success').show();
    }).fail(function(xhr) {
      console.log(xhr.responseJSON.email[0]);
      form.parent().find('.submit-error').text(xhr.responseJSON.email[0]).show();
    });

    return false;
  });
});